import { MePage } from "@features/me/components/MePage";
import { requireRouteAudience } from "@services/router/routeAccess";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_layout/me")({
	component: MePage,
	beforeLoad: requireRouteAudience(["staff", "student"]),
	staticData: {
		crumb: { label: "Me" },
	},
});
